export default {
  columns: {
    offerName: 'Tilbudsnavn',
    type: 'Type',
    status: 'Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    details: 'Detaljer',
    schedule: 'Tidsplan',
    startDate: 'Startdato',
    images: 'Billede',
  },
  actions: {
    edit: 'Rediger',
    rename: 'Omdøb',
    delete: 'Slet',
    set_active: 'Sæt aktiv',
    set_inactive: 'Sæt inaktiv',
    cancel: 'Annuller',
    confirm: 'Bekræft',
    activate: 'Erstat og aktivér',
    manage_images: 'Rediger billede',
  },
  toasts: {
    offer_enabled: '{{offer}} er nu det aktive tilbud for {{for}}',
    offer_disabled: '{{offer}} er sat til inaktiv.',
    update_failed: 'Tilbuddet kunne ikke opdateres.',
    successfully_deleted: 'Tilbuddet er slettet',
    delete_failed: 'Tilbuddet kunne ikke slettes',
  },
  title: 'Administrer alle tilbud',
  popups: {
    delete: {
      title: 'Er du sikker på, at du vil slette dette tilbud?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'Det er ikke tilladt at erstatte hovedtilbud',
      title: 'Vil du erstatte det aktive tilbud i denne periode?',
      description:
        'Du aktiverer {{offer}} på {{weekday}}{{between}}. Dette deaktiverer det nuværende aktive tilbud {{currentOffer}} i samme periode.',
      between: ', mellem {{start}}-{{end}}',
    },
  },
};
